module.exports = __webpack_public_path__ + "static/media/hittite_preview.d52b07ea.png";